<template>
  <div>
    <h1>Labpage</h1>
    <hr />
    <b-card>
      <b-card-body>
        <b-row v-for="(f, i) in filters" :key="i">
          <b-col cols="1">
            <b-icon-x-circle @click="filters.splice(i, 1)"> </b-icon-x-circle>
          </b-col>
          <b-col cols="3">
            <qvcond
              :fields="columns"
              v-bind:cond="f"
              v-on:change="OnChange"
            ></qvcond>
          </b-col>
          <b-col>
            {{ JSON.stringify(f) }}
          </b-col>
        </b-row>
        <b-button @click="AddNew()">+</b-button>{{GetQuery()}}
      </b-card-body>
    </b-card>
    <h1>Komponent</h1>
    <queryviewconditionset></queryviewconditionset>
  </div>
</template>
<script>
import queryviewconditionset from "../queryview/queryviewconditionset";
import qvcond from "../queryview/queryviewcondition";
import { qvCondition } from "../../lib/qvcondition.js";
const cndLib = new qvCondition();

export default {
  components: { qvcond, queryviewconditionset },
  data() {
    return {
      filters: [],
      columns: [
        {
          id: 3378,
          Name: "Bes postnr",
          ColName: "Bes postnr",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "int",
        },
        {
          id: 3379,
          Name: "Bestammelseort",
          ColName: "Bestammelseort",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: null,
          ColumnType: "varchar",
        },
        {
          id: 3374,
          Name: "AvstKlass",
          ColName: "AvstKlass",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "int",
        },
        {
          id: 3397,
          Name: "Kundnettofrakt",
          ColName: "Kundnettofrakt",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "decimal",
        },
        {
          id: 3385,
          Name: "EstNetto",
          ColName: "EstNetto",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "decimal",
        },
        {
          id: 3389,
          Name: "Fraktsedelsnr",
          ColName: "Fraktsedelsnr",
          Width: 120,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "bigint",
        },
        {
          id: 3398,
          Name: "Kundnr",
          ColName: "Kundnr",
          Width: 80,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "int",
        },
        {
          id: 3396,
          Name: "Kundnamn",
          ColName: "Kundnamn",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":1}',
          ColumnType: "varchar",
        },
        {
          id: 3406,
          Name: "Sändningstypkod",
          ColName: "Sändningstypkod",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "varchar",
        },
        {
          id: 3420,
          Name: "Vkl",
          ColName: "Vkl",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "int",
        },
        {
          id: 3419,
          Name: "Transportörsnr",
          ColName: "Transportörsnr",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: '{"align":2}',
          ColumnType: "int",
        },
        {
          id: 3761,
          Name: "Transportör",
          ColName: "tspnamn",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: null,
          ColumnType: "varchar",
        },
        {
          id: 3370,
          Name: "Testresultat",
          ColName: "AnalyzeText",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat: null,
          ColumnType: "varchar",
        },
        {
          id: 3473,
          Name: "Varningar",
          ColName: "WarningCount",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat:
            '{"align":1,"cnds":[{"type":"bwn","min":"1","max":"","css":"qvcell2","bgcolor":"rgb(233,177,36)","color":"rgb(179,72,61)"}]}',
          ColumnType: "int",
        },
        {
          id: 3483,
          Name: "Fel",
          ColName: "ErrorCount",
          Width: 50,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat:
            '{"align":1,"cnds":[{"type":"bwn","min":1,"max":null,"css":"qvcell1","bgcolor":"rgb(199,14,48)","color":"rgb(245,225,153)"}]}',
          ColumnType: "int",
        },
        {
          id: 3538,
          Name: "TotEstDiff",
          ColName: "TotEstDiff",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: null,
          CsFormat:
            '{"cnds":[{"type":"bwn","bgcolor":"rgb(225,165,198)","color":"rgb(115,78,82)","max":"-0.5"}],"align":2}',
          ColumnType: "decimal",
        },
        {
          id: 3400,
          Name: "Lf-datum",
          ColName: "Lf-datum",
          Width: 0,
          Filter: null,
          OrderBy: "",
          Visible: true,
          ColOrder: 0,
          Format: "{0:yyyy-MM-dd}",
          CsFormat: null,
          ColumnType: "datetime",
        },
      ],
    };
  },
  methods: {
    OnChange(c) {
      console.log(c);
      var i = this.filters.findIndex((x) => x === c.cond);
      if (i >= 0) {
        //Object.assign(this.filters[i], c.newvalue);
        var f = this.filters[i];
        var n = c.newvalue;
        f.min = n.min;
        f.max = n.max;
        f.eq = n.eq;
        
        this.$forceUpdate();
      } else {
        console.log('Kan inte hitta!')
      }
    },
    AddNew() {
      var f = {field:"Kundnettofrakt", type:null,min:null,max:null,eq:null};
      this.filters.push(f);
    },
    GetQuery() {
      var res = [];
      this.filters.map(x => {
        var flt = cndLib.GetFilter(x);
        if(flt)
          res.push(`(${flt})`)
        });
      return res.join(' AND ');
    },
  },
};
</script>